import { NgModule } from '@angular/core'
import { SharingRecordingsFeatureService } from './sharing-recordings-feature.service'

@NgModule({
  providers: [SharingRecordingsFeatureService],
})
export class SharingRecordingsFeatureModule {}
